import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'react-recompose';
import ModalDlg from 'components/Basic/ModalDlg';
import { Button } from 'antd';
import { CopyFilled } from '@ant-design/icons';
const AuditLogsModal = ({ intl, isOpenModal, onCloseModal, auditLogsInfo }) => {
  const capitalizeFirst = str => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const getFormattedChanges = changes => {
    if (!changes) return '';
    try {
      const parsed = typeof changes === 'string' ? JSON.parse(changes) : changes;
      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      return changes;
    }
  };

  const getActorMetadata = actor => {
    if (!actor) return '';
    try {
      const parsed = typeof actor === 'string' ? JSON.parse(actor) : actor;
      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      return actor;
    }
  };

  const formattedActorMetadata = getActorMetadata(auditLogsInfo?.actorMetadata);

  const formattedChanges = getFormattedChanges(auditLogsInfo?.changes);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(formattedChanges);
  };

  const copyActorMetadataToClipboard = () => {
    navigator.clipboard.writeText(formattedActorMetadata);
  };

  return (
    <ModalDlg className="auditLogs_view_modal" visible={isOpenModal} width={800} handleCancel={onCloseModal} isCenter>
      <div className="modal_header">
        <h3>{capitalizeFirst(auditLogsInfo?.entityType)}</h3>
      </div>
      <div className="modal_content">
        <div className="modal_body">
          <div className="summary_section">
            <div className="summary_item">
              <span className="label">
                <FormattedMessage id="Action" />
              </span>
              <span className="value">
                {auditLogsInfo?.action ? intl.formatMessage({ id: auditLogsInfo?.action }) : '-'}
              </span>
            </div>
            <div className="summary_item">
              <span className="label">
                <FormattedMessage id="Actor ID" />
              </span>
              <span className="value">{auditLogsInfo?.actorId || '-'}</span>
            </div>
            <div className="summary_item">
              <span className="label">
                <FormattedMessage id="Actor" />
              </span>
              <span className="value">
                {auditLogsInfo?.actorType ? intl.formatMessage({ id: auditLogsInfo?.actorType }) : '-'}
              </span>
            </div>
          </div>

          <div className="actor_metadata_section">
            <h4>
              <FormattedMessage id="actor metadata" />
            </h4>
            <div className="json_wrapper">
              <pre>{formattedActorMetadata}</pre>
            </div>
            <Button className="copy_btn" onClick={copyActorMetadataToClipboard}>
              <FormattedMessage id="Copy" />
              <CopyFilled />
            </Button>
          </div>

          <div className="changes_section">
            <h4>
              <FormattedMessage id="changes" />
            </h4>
            <div className="json_wrapper">
              <pre>{formattedChanges}</pre>
            </div>
            <Button className="copy_btn" onClick={copyToClipboard}>
              <FormattedMessage id="Copy" />
              <CopyFilled />
            </Button>
          </div>
        </div>
      </div>
      <div className="modal_footer">
        <Button className="close_btn" onClick={onCloseModal}>
          <FormattedMessage id="Close" />
        </Button>
      </div>
    </ModalDlg>
  );
};

AuditLogsModal.defaultProps = {
  isOpenModal: false,
  audiLogsInfo: null,
};

export default compose(injectIntl)(AuditLogsModal);
